import AttributeBar from './AttributeBar.vue';

export default AttributeBar;
